module.exports = __webpack_public_path__ + "img/venmo-icon.c11bc8b3.svg";